import styles from "./NewTestimonial.module.css";
import qot from "../assets/quote.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import left from "../assets/left.png";
import right from "../assets/right.png";
import { useRef } from "react";

const data = {
  title: "Client Testimonials",
  subtitle:
    "Eliminate the need for multiple-point solutions. EvoNext's unified platform offers centralized solutions for risk and compliance challenges. Our user-friendly interface enables informed decision-making across stakeholders and functions, while robust features enable automation and reduce effort. ",
};

const testimonials = [
  {
    desig: "Associate Vice President Product Management",
    name: "Asha Mehta",
    company: "Tata Capital Limited",
    text: "As a current user of EvoNext’s Process Change Management software, I find the built-in discussion board incredibly useful. It streamlines collaboration across teams, ensures transparent communication, and keeps all change-related conversations in one place—making decision-making faster and more aligned.",
  },
  {
    desig: "Former Vice President – Digital Technology ",
    name: "Balaji Naik",
    company: "ICICI Prudential Life Insurance Company Limited",
    text: "I have had the opportunity to work with DePronto for our IT services and staff augmentation needs. Their ability to quickly provide skilled professionals, aligned with our project goals, has been invaluable. The team is responsive and flexible.",
  },
  {
    desig: "EVP & IT Head",
    name: "Aliasgar Karachiwala",
    company: "Ratnakar Bank Limited",
    text: "EvoNext’s platform brought structure and clarity to our change management processes. The workflows, reporting, and collaboration tools were thoughtfully designed and helped us drive consistency across teams. It’s a solid solution with a strong focus on governance and operational efficiency.",
  },
  {
    desig: "Digital and Strategy Manager",
    name: "Anjan Baug",
    company: "Tata Capital Limited",
    text: "EvoNext has been a reliable solution for managing change workflows across our entities. From an IT risk management perspective, it provides the control, traceability, and governance we need, while also being flexible enough to adapt to our internal policies and compliance standards.",
  },
  // {
  //   name: "Nikhil Gadre",
  //   company: "Mahindra Finance",
  //   text: "Product & Process Change Management workflow software was one of a kind–it enabled us to establish strong governance, meet regulatory requirements, and manage everything efficiently with an lean team.",
  // },
];

const NewTestimonualCard = ({ name, designation, company, text }) => {
  return (
    <div className={styles.outer}>
      <div className={styles.inner}>
        <p className={styles.name}>{name}</p>
        <p className={styles.desig}>{designation}</p>
        <p className={styles.company}>{company}</p>
        <p className={styles.desc}>{text}</p>
      </div>
      <div className={styles.icon}>
        <img src={qot} alt="" />
      </div>
    </div>
  );
};

const NewTestimonual = () => {
  const sliderRef = useRef();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false, // hide built-in arrows since we use custom buttons
  };

  return (
    <div className={styles.cnt}>
      <div className={styles.ourtextContainer}>
        <div className={styles.titleour}>{data.title}</div>
      </div>

      <div
        style={{
          width: 956,
          margin: "auto",
          position: "relative",
        }}
      >
        <Slider {...settings} ref={sliderRef}>
          {testimonials.map((item, index) => (
            <NewTestimonualCard
              key={index}
              name={item.name}
              designation={item.desig}
              text={item.text}
              company={item.company}
            />
          ))}
        </Slider>

        {/* Left and Right Custom Buttons */}
      </div>
      <button
        className={styles.leftt}
        onClick={() => sliderRef.current?.slickPrev()}
      >
        <img src={left} alt="Previous" />
      </button>

      <button
        className={styles.rightt}
        onClick={() => sliderRef.current?.slickNext()}
      >
        <img src={right} alt="Next" />
      </button>
    </div>
  );
};

export default NewTestimonual;
